import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/common/input";
import { CalculationFilterStatus } from "../../../../config/enums/ProductType.enum";
import ProductFilterPanel from "./ProductFilterPanel";

interface ProductListToolbarProps {
  searchKey: string;
  onSearchChange: (value: string) => void;
  refetchWithFilters: (calculateStatus: CalculationFilterStatus, orderBy: string) => void;
}

/**
 * Search + filter row, styled after `IngredientListToolbar`
 * (src/screens/lcaIngredients/ingredientList/components/IngredientListToolbar.tsx):
 * a relative-positioned box with an absolutely-positioned icon and the
 * common `Input` padded clear of it.
 */
const ProductListToolbar = ({ searchKey, onSearchChange, refetchWithFilters }: ProductListToolbarProps) => {
  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center">
      <div className="tw-relative tw-w-full sm:tw-w-72">
        <Search
          size={16}
          className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-muted-foreground"
        />
        <Input
          value={searchKey}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search product, register number, sales unit"
          className="tw-pl-9"
        />
      </div>
      <ProductFilterPanel refetchWithFilters={refetchWithFilters} />
    </div>
  );
};

export default ProductListToolbar;
